import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonTertiary, Checkbox } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ExperienceTransferDetailsContainerProps } from '../types';
import { endpoints } from 'app/area/experience-transfer/form/endpoints';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ExperienceTransferPicker } from 'app/area/experience-transfer/form/components/experience-transfer-picker';
import { ExperienceTransferMessages } from 'app/area/experience-transfer/form/components/experience-transfer-messages';
import { ExperienceTransferItem } from 'app/area/experience-transfer/form/types-store';
import { formFields } from 'app/area/experience-transfer/form/constants';
import { hasKeyViolationValidation } from 'app/area/experience-transfer/form/utils/validation';
import { ExtraFooterButton } from 'ui/common/select/types';
import styles from './experience-transfer-details.scss';

export const ExperienceTransferDetailsContainer: React.FC<ExperienceTransferDetailsContainerProps> = ({
  experienceTransferItem, translation, updateItem, options, loadOptions, validation, resetValidation, clearValidation
}) => {

  const checkboxOnChange = (active: number) => {
    updateItem({ active: !!active });
    resetValidation(experienceTransferItem?.id);
  };

  const fieldOnChange = (value: Partial<ExperienceTransferItem>) => {
    updateItem(value);
    resetValidation(experienceTransferItem?.id);
    hasKeyViolationValidation(validation) && clearValidation();
  };

  const manageOptionsButton = (label: string, handleClick: () => void) =>
    (onClose: () => void) =>
      <ButtonTertiary onClick={handleClick}>
        {label}
      </ButtonTertiary>;

  const singlePickerCreator = (id: string, label: string, endpoint: string,
    extraFooterButton?: ExtraFooterButton) =>
    <ExperienceTransferPicker
      id={id}
      label={label}
      valueItem={experienceTransferItem?.[id]}
      codeOptions={(options?.[id]?.codes || []) as CodeComplexValue<number>[]}
      endpoint={endpoint}
      fetching={options?.[id]?.fetching}
      loadOptions={loadOptions}
      translation={translation}
      validation={validation}
      updateItem={fieldOnChange}
      extraFooterButton={extraFooterButton} />;

  return <div className={styles.itemForm}>
    <MainGridContainer>
      <ExperienceTransferMessages
        validation={validation}
        translation={translation} />
      <div className={`row ${styles.spacing}`}>
        <div className="col-lg-6 col-sm-12">
          {singlePickerCreator(
            formFields.subscriberGroup,
            translation.subscriber_group,
            endpoints.subscriberGroupOptions
          )}
        </div>
        <div className="col-lg-6 col-sm-12">
          {singlePickerCreator(
            formFields.criteria,
            translation.criteria,
            endpoints.criteriaOptions
          )}
        </div>
      </div>
      <div className={`row ${styles.spacing}`}>
        <div className="col-lg-6 col-sm-12">
          {singlePickerCreator(
            formFields.caseType,
            translation.case_type,
            endpoints.caseTypeOptions
          )}
        </div>
        <div className="col-lg-6 col-sm-12">
          {singlePickerCreator(
            formFields.operation,
            translation.operation,
            endpoints.operationOptions,
            manageOptionsButton(
              translation.manage_options,
              navigate.toOperations)
          )}
        </div>
      </div>
      <div className={`row ${styles.spacing}`}>
        <div className="col-lg-6 col-sm-12">
          <Checkbox
            className={'mx-3'}
            componentId={'active-checkbox'}
            onChange={checkboxOnChange}
            label={{ visible: true, text: translation.active }}
            value={experienceTransferItem?.active ? 1 : 0} />
        </div>
      </div>
    </MainGridContainer>
  </div>;
};
